export default __webpack_public_path__ + "461bea910b2e60532c7f03c4c76763d1.png";